import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DashboardService } from '../../../../../service/events/dashboard.service';
import { TareasApiService } from '../../../../../service/api/tareas-api.service';
import { FincasApiService } from '../../../../../service/api/fincas-api.service';
import { ClientesApiService } from '../../../../../service/api/clientes-api.service';
import { TrabajadoresApiService } from '../../../../../service/api/trabajadores-api.service';
import { TareaCespedModel } from '../../../../../models/tareas/tarea-cesped.model';
import { MtoReactiveFormComponent } from '../../mto-reactive/mto-reactive-form.component';
import { TareasMtoCespedFormDefinition } from './form-control/form-definition';

@Component({
    selector: 'app-tareas-mto-cesped-form',
    standalone: false,
    templateUrl: './tareas-mto-cesped-form.component.html',
    styleUrls: ['./tareas-mto-cesped-form.component.scss'],
})
export class TareasMtoCespedFormComponent extends MtoReactiveFormComponent<TareaCespedModel, TareasMtoCespedFormDefinition> {
    constructor(
        route: ActivatedRoute,
        dashboard: DashboardService,
        fincasApi: FincasApiService,
        clientesApi: ClientesApiService,
        trabajadoresApi: TrabajadoresApiService,
        tareasApi: TareasApiService,
        router: Router,
    ) {
        super(
            route,
            router,
            dashboard,
            fincasApi,
            clientesApi,
            trabajadoresApi,
            tareasApi.mtoCesped.PUT,
            tareasApi.mtoCesped.POST,
            tareasApi.mtoCesped.GET,
            'cesped',
            'Actualizar Tarea Cesped',
            'Realizar Tarea Cesped',
            'Duplicar Tarea Cesped',
            {
                loadingLabel: 'Cargando datos del formulario de césped/cavado...',
                errorContext: 'césped/cavado',
            },
        );
    }

    protected createFormDefinition(): TareasMtoCespedFormDefinition {
        return new TareasMtoCespedFormDefinition(this.getType(), this.model);
    }
}
